/* eslint-disable import/no-unresolved */
import { createResourceQuery } from '@funtech-int/rival';
import { useResources } from '@funtech-int/rival-react';

import { useLocale } from '@/shared/hooks/useLocale';

interface DictionaryQueryContext {
    lang: string;
}

const dictionaryQuery = createResourceQuery<DictionaryQueryContext, any>({
    key(ctx) {
        return ctx.lang;
    },
    fetch(ctx) {
        let promise = Promise.resolve({ default: {} });

        switch (ctx.lang) {
            case 'ar':
                // @ts-ignore generated file
                promise = import('dictionaries/ar.json');
                break;
            case 'ru':
                // @ts-ignore generated file
                promise = import('dictionaries/ru.json');
                break;
            case 'uz':
                // @ts-ignore generated file
                promise = import('dictionaries/uz.json');
                break;
            default:
                // @ts-ignore generated file
                promise = import('dictionaries/en.json');
        }

        return promise.then((module) => module.default);
    },
});

export function useDictionary() {
    const { lang } = useLocale();

    const [dictionary] = useResources(
        dictionaryQuery({
            lang,
        })
    );

    return dictionary;
}
